import { LoginForm } from '@/components/login-form'
import { Card, CardContent } from '@/components/ui/card'
import LogoNew from '@/assets/logo-new.svg'

export default function LoginPage() {
  return (
    <div className='flex min-h-svh flex-col items-center justify-center p-6 md:p-10'>
      <div className='w-full max-w-sm'>
        <div className='flex justify-center mb-8'>
          <img src={LogoNew} alt='BSOK' className='h-12 w-auto' />
        </div>
        <Card>
          <CardContent>
            <LoginForm />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
